import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('sms/list', { params });
  },
  async getMobiles(params: any) {
    return axios.post('sms/get-mobiles', qs.stringify(params));
  },
  async add(params: any) {
    return axios.post('sms/add', qs.stringify(params));
  },
  async tpllist(params: any) {
    return axios.get('sms/tpl-list', { params });
  },
  async addtpl(params: any) {
    return axios.post('sms/add-tpl', qs.stringify(params));
  },
  async edittpl(params: any) {
    return axios.post('sms/edit-tpl', qs.stringify(params));
  },
  async tpldetail(params: any) {
    return axios.get('sms/tpl-detail', { params });
  },
  async deletetpl(params: any) {
    return axios.post('sms/delete-tpl', qs.stringify(params));
  },
  async tplselect(params: any) {
    return axios.get('sms/tpl-select', { params });
  },
  async app(params: any) {
    return axios.get('sms/app', { params });
  },
  async appadd(params: any) {
    return axios.post('sms/appadd', qs.stringify(params));
  },
  async admin(params: any) {
    return axios.get('sms/admin', { params })
  },
  async sendPending(params: any) {
    return axios.get('sms/send-pending', { params })
  }
};
